<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    url: {
        type: String,
        default: null,
    },
});

const emit = defineEmits(['request-setup']);

function openSetup() {
    if (props.url) {
        window.open(props.url, '_blank', 'noopener');
    } else {
        emit('request-setup');
    }
}
</script>

<template>
    <div class="mt-6 border border-slate-200 rounded-xl bg-white px-6 py-5 flex items-center justify-between">
        <div>
            <h3 class="text-base font-semibold text-slate-900">Add a card for future purchases</h3>
            <p class="mt-1 text-sm text-slate-600">
                We'll keep it on file to instantly bill add-ons like AI credits, extra emails, or webinars.
            </p>
        </div>
        <button
            type="button"
            class="inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white bg-myflowGreen-900 hover:bg-myflowGreen-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-myflowGreen-900"
            @click="openSetup"
        >
            Add card
        </button>
    </div>
</template>
